import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  // apiKey: "AIzaSyD9YuvL8-aTZQt_kSkjdMJ27CFFRLKITpc",
  // authDomain: "my-react-app-282f6.firebaseapp.com",
  // projectId: "my-react-app-282f6",
  // storageBucket: "my-react-app-282f6.firebasestorage.app",
  // messagingSenderId: "475764256931",
  // appId: "1:475764256931:web:d3a3d4878b747284b38f16"
  apiKey: "AIzaSyA7NUC0KbchFjYDHPi7k5Zneu8CibX0gGo",
  authDomain: "reflections-portal-oc.firebaseapp.com",
  projectId: "reflections-portal-oc",
  storageBucket: "reflections-portal-oc.firebasestorage.app",
  messagingSenderId: "1017309552142",
  appId: "1:1017309552142:web:2be9501716dda95aa2e65f",
  measurementId: "G-0668TMR3QM"
};

// const app = initializeApp(firebaseConfig);
// export const db = getFirestore(app);

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export { app }; // <-- export app
